import React, {useState, useRef, useEffect} from "react";

import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  Button,
  Avatar,
  Text,
  Flex,
  VStack,
  useToast,
  Card,
  CardHeader,
  CardBody,
  Heading,
  IconButton,
  useDisclosure,
  Tooltip,
  Badge,
  Stack,
  Collapse,
  HStack,
  Radio,
  RadioGroup,
  Icon,
} from "@chakra-ui/react";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
} from "@chakra-ui/react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";

export default function ProductsInformation({appt, schState, dispatch}) {
  const [open, setOpen] = useState(false);
  const [prevAppt, setPrevAppt] = useState(appt);

  if (appt && prevAppt !== appt) {
    setPrevAppt(appt);
  }

  // Get both products and add-on services
  const products = appt?.products || [];
  const addOnServices = appt?.addOnServices || [];
  const hasAddOns = products.length > 0 || addOnServices.length > 0;

  return (
    <Accordion index={open ? [0] : []} allowToggle>
      <AccordionItem border="none">
        <h2>
          <AccordionButton
            color={"#5754FF"}
            borderBottom={"1px solid"}
            borderBottomColor={"#5754FF"}
            fontWeight={500}
            fontSize={"13px"}
            onClick={() => {
              setOpen((prev) => !prev);
            }}
          >
            <Box as="span" flex="1" textAlign="left">
              Add-ons
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4} bg="white">
          <TableContainer w={"full"} maxH={"10rem"} overflowY="scroll">
            {hasAddOns ? (
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Type</Th>
                    <Th>Name</Th>
                    <Th>Quantity</Th>
                    <Th isNumeric>Price</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {/* Render Add-on Services */}
                  {addOnServices.map((service, i) => (
                    <Tr key={`service-${i}`}>
                      <Td>
                        <Badge colorScheme="blue" fontSize="10px">
                          Service
                        </Badge>
                      </Td>
                      <Td whiteSpace={"pre-wrap"}>
                        {service.serviceType || "Add-on Service"}
                      </Td>
                      <Td textAlign={"center"}>{service.quantity || 1}</Td>
                      <Td isNumeric>${(service.price || 0).toFixed(2)}</Td>
                    </Tr>
                  ))}

                  {/* Render Products */}
                  {products.map((product, i) => (
                    <Tr key={`product-${i}`}>
                      <Td>
                        <Badge colorScheme="green" fontSize="10px">
                          Product
                        </Badge>
                      </Td>
                      <Td whiteSpace={"pre-wrap"}>{product.name}</Td>
                      <Td textAlign={"center"}>{product.quantity}</Td>
                      <Td isNumeric>
                        ${((product.onSale ? product.salePrice : product.price) || 0).toFixed(2)}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <Text fontSize="sm" color="gray.500" p={2}>
                No add-ons for this appointment
              </Text>
            )}
          </TableContainer>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
